import {EditorPointTransformTranslate} from "../editor/editor-point-transform-translate";
import {MapEvent} from "../../../document/model/map";

export class GeoreferencerPointTransformTranslate extends EditorPointTransformTranslate {

  buildInitialState(initialState: StateType): StateType {
    super.buildInitialState(initialState)
    if (this.transformedFeature)
      this.controller.mapInstance.fire(MapEvent.PinSelected, {feature: (this.transformedFeature.toGeoJSON() as Feature)});


  }

  public getVertexIcon(): string {
    return "aim1";
  }

  showHistory(state: TransformInteractionState): boolean {
    return false;
  }


  canSave(state: TransformInteractionState): boolean {
    return false;
  }

  useHistory(state: StateType): boolean {
    return false;
  }

  public transform(state: TransformInteractionState, e: MapMouseEvent, snapPoint: SnapPoint) {
    this.transformedFeature.setCoordinates(snapPoint.point as any);
    this.displayDrawFeature(this.transformedFeature);
    this.controller.mapInstance.fire(MapEvent.PinAdd, {feature: (this.transformedFeature.toGeoJSON() as Feature)});
  }

}
